import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, CircularProgress, Snackbar } from '@mui/material';
// config
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { QUERY_MAIN_DEVICE } from '../../graphql/device';
import { HEADER, NAVBAR } from '../../config';
//
import DashboardHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
import LicenseHandler from '../../components/LicenseHandler';
import { useErrorMonitor } from '../../ErrorMonitorContext';
import { handleSelectPrimaryDevice } from '../../utils/selectPrimaryDevice';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(({ theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 18,
  marginLeft: NAVBAR.DASHBOARD_WIDTH - 30,
  paddingBottom: 18,
  [theme.breakpoints.up('lg')]: {
    marginLeft: 0,
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { t } = useTranslation();
  const { failedCount } = useErrorMonitor(); // Access the context
  const [openToast, setOpenToast] = useState(false);
  const [getMainDevice, { loading }] = useLazyQuery(QUERY_MAIN_DEVICE);

  const handleCloseToast = () => {
    setOpenToast(false)
  }

  useEffect(() => {
    if (failedCount >= 20) {
      setOpenToast(true);
    }
  }, [failedCount]);

  return (
    <>
      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: 1,
          bgcolor: '#F5F5F5',
        }}
      >
        <DashboardHeader />

        <NavbarVertical />

        <MainStyle>
          <Outlet />
        </MainStyle>

        <LicenseHandler />

        <Snackbar
          open={openToast}
          onClose={() => setOpenToast(false)}
          message={t('Our system detected abnormal failures in some of the requests. Please switch to primary device again.')}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          ContentProps={{
            sx: { backgroundColor: '#d32f2f', color: '#fff' },
          }}
          action={
            <Button
              size="small"
              variant="outlined"
              sx={{
                color: '#fff',
                borderColor: '#fff',
                width: '9.375rem'
              }}
              onClick={() => handleSelectPrimaryDevice(getMainDevice, handleCloseToast)}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : t('Select Primary Device')}
            </Button>
          }
        />
      </Box>
    </>
  );
}
